exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div_LoginScreen{\n    padding: 2em;\n}\n.div_LoginScreenLinkToForgotPassword{\n    display: flex;\n    justify-content: flex-start;\n}\n.p_LinkToForgotPassword{\n    color:#e6e6e6;\n}", ""]);

// exports
